import React, { useEffect, useRef, useState } from "react";

import { TextField } from "@material-ui/core";

import CheckCircleIcon from "@material-ui/icons/CheckCircle";

import Button from "../../../components/CustomButtons/Button";

const TextFieldContentWidth = ({ value, onChange, endEdit }) => {
  const [currentValue, setCurrentValue] = useState(value);
  const inputRef = useRef(null);
  useEffect(() => {
    inputRef.current.focus();
  }, [inputRef]);

  return (
    <React.Fragment>
      <TextField
        inputRef={inputRef}
        defaultValue={currentValue}
        value={currentValue}
        type={"number"}
        inputProps={{
          style: {
            textAlign: "center",
            width: `${currentValue.toString().length * 10 + 20}px`,
          },
        }}
        onChange={(e) => {
          setCurrentValue(e?.target?.value || 0);
        }}
        onKeyPress={(e) => {
          if (e.key === "Enter") {
            const updateValue = parseInt(e?.target?.value) || 0;
            onChange(updateValue);
            endEdit();
            e.preventDefault();
          }
        }}
      />
      <Button
        justIcon
        round
        simple
        color="success"
        onClick={() => {
          onChange(parseInt(currentValue));
          endEdit();
        }}
      >
        <CheckCircleIcon />
      </Button>
    </React.Fragment>
  );
};

export default React.memo(TextFieldContentWidth);
